import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { AuthShell, Field } from "./Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Unisciti a WYD" subtitle="Crea il tuo account gratuito">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Nome" value={name} onChange={setName} testid="register-name" />
        <Field label="Email" type="email" value={email} onChange={setEmail} testid="register-email" />
        <Field label="Password (min 6 caratteri)" type="password" value={password} onChange={setPassword} testid="register-password" />
        {error && <p data-testid="register-error" className="text-sm text-wyd-accent">{error}</p>}
        <button data-testid="register-submit" disabled={loading}
          className="w-full py-3 rounded-full bg-wyd-accent text-wyd-bg font-semibold hover:glow-magenta transition-shadow duration-300 disabled:opacity-60">
          {loading ? "Creazione..." : "Registrati"}
        </button>
      </form>
      <p className="mt-6 text-sm text-wyd-muted text-center">
        Hai già un account? <Link to="/login" className="text-wyd-accent font-medium">Accedi</Link>
      </p>
    </AuthShell>
  );
}
